import { atom } from 'recoil';

const JobCountState = atom({
    key: 'jobCountState',
    default: null
});

export default JobCountState;